"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFields = exports.FIELDS_MAP = void 0;
exports.FIELDS_MAP = {
    id: 'id',
    b: 'שם',
    c: 'שם משפחה',
    d: 'גיל',
    e: 'מין',
    f: 'מאיפה בארץ',
    h: 'subtitle - 1',
    i: 'subtitle - final',
    j: 'לינק לתמונה',
    l: 'טקסט חופשי n12',
    video: 'קוד אמבד לפופ אפ (אם יש)',
    article: 'לינק לכתבה',
    group: 'קבוצה',
    status: 'הוחזרו',
    line1: 'משפט 1',
    line2: 'משפט 2',
    silhouette: 'אחרונים',
};
/**
 * a: rank,
 * b: name
 * c: surname
 * d: age,
 * e: sex,
 * f: city,
 * g: role,
 * h: subtitle1,
 * i: subtitleFinal,
 * j: photo,
 * k: unit
 * l: description,
 */
function replaceFields(data) {
    var result = data.map(function (item) {
        var newItem = {};
        Object.entries(item).forEach(function (_a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            var mappedKey = (_b = Object.entries(exports.FIELDS_MAP).find(function (_a) {
                var _b = __read(_a, 2), v = _b[1];
                return v === key;
            })) === null || _b === void 0 ? void 0 : _b[0];
            if (mappedKey) {
                newItem[mappedKey] = value;
            }
        });
        return newItem;
    });
    return result;
}
exports.replaceFields = replaceFields;
//# sourceMappingURL=replace-fields.js.map